import { Button } from "@/components/ui/button";
import LoadingSpinerV2 from "@/components/ui/LoadingSpinverV2";

import SupabasePool from "@/lib/supabaseClient";
import { cn } from "@/lib/utils";
import { ProjectPostProps } from "@/type/ProjectTypes";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Pin } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ListItem(e: ProjectPostProps) {
  const [pin, setPin] = useState(!!e.project_pin);
  const nav = useNavigate();
  const queryClient = useQueryClient();

  // 고정
  const { mutate, isPending } = useMutation({
    mutationFn: async (pin: boolean) => {
      const pool = SupabasePool.getInstance();

      if (!pin) {
        // 고정 추가
        const res = await pool
          .from("project_pin")
          .insert({ fk_project_id: e.id })
          .select()
          .maybeSingle();
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return { ok: true, pinned: true, raw: res };
      } else {
        // 고정 삭제
        const res = await pool
          .from("project_pin")
          .delete()
          .eq("fk_project_id", e.id)
          .select()
          .maybeSingle();

        await new Promise((resolve) => setTimeout(resolve, 1000));

        return { ok: true, pinned: false, raw: res };
      }
    },
    onSuccess: (data) => {
      setPin(data.pinned);
      queryClient.invalidateQueries({ queryKey: ["project-pin"] });
      queryClient.invalidateQueries({ queryKey: ["project-list"] });
    },
  });

  return (
    <li className="py-3 px-3 flex items-center justify-between cursor-pointer hover:underline ">
      <span onClick={() => nav(`/work/${e.id}`)}>{e.title}</span>

      <div className="flex gap-2">
        <Button
          onClick={() => mutate(pin)}
          className={cn("text-xs", pin && "border-indigo-300! text-indigo-200")}
          variant={"outline"}
          disabled={isPending}
        >
          {isPending ? (
            <LoadingSpinerV2 />
          ) : !pin ? (
            "고정 "
          ) : (
            <>
              <Pin /> 고정 중
            </>
          )}
        </Button>
        <Button className="text-xs" variant={"ghost"}>
          수정
        </Button>{" "}
        <Button className="text-xs" variant={"ghost"}>
          삭제
        </Button>{" "}
      </div>
    </li>
  );
}
